import React, { forwardRef } from 'react';
import MuiPaper, { PaperProps } from '@material-ui/core/Paper';

const Paper = forwardRef((props: PaperProps, ref) => {
  return (
    <MuiPaper ref={ref} {...props}>
      {props.children}
    </MuiPaper>
  );
});

export default Paper;
